<template>
    <div>
      <div class="col-md-3 col-xs-12" v-if="message[0]">
        <va-small-box
          v-if="message[0].totalCollection === null"
          class="info-box box-blue"
          icon="ion-briefcase "
          :title=0
          description="Total Collection Amount"
          @more-click="clickToSmallBox"
          moreText="More info">
        </va-small-box>
        <va-small-box
          v-else
          class="info-box box-blue"
          icon="ion-briefcase "
          :title=message[0].totalCollection
          description="Total Collection Amount"
          @more-click="clickToSmallBox"
          moreText="More info">
        </va-small-box>
      </div>
    </div>
</template>
<script>
import VASmallBox from '../widgets/VASmallBox.vue'
export default {
  props: ['message'],
  data () {
    return {
      totalAmount: 0
    }
  },
  methods: {
    clickToSmallBox () {
      this.$router.push({name: 'showCollection'})
    }
  },
  components: {
    'va-small-box': VASmallBox
  }
}
</script>
<style >
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-blue {
    background-color:#003c60;
    color: #fff;
  }
   /* .iconColor {
    color: rgb(12, 156, 55);
  } */
  /* .small-box > .small-box-footer {
  background: rgb(12, 156, 55);
} */
</style>



// WEBPACK FOOTER //
// totalcollection.vue?54ad6eac